export default __webpack_public_path__ + "static/media/info.42c4dac7.svg";